import { MinusIcon, PlusIcon } from "@heroicons/react/20/solid";
import { addMonths, format } from "date-fns";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";

import { Actions as ASSET_ACTIONS } from "../../store/actions/assetActions";
import { Actions as EMPLOYEEACTIONS } from "../../store/actions/employeeActions";
import LoadingContent from "../common/LoadingContent";

import AssetAuditLogs from "./AssetAuditLogs";
import AssetDetails from "./AssetDetails";
import AssignmentHistory from "./assignments/AssignmentHistory";
import AssignAssetModal from "./modals/AssignAssetModal";
import UnassignAssetModal from "./modals/UnassignAssetModal";

const Asset = ({
	asset,
	assignedTo,
	assetTab,
	tab,
	getAsset,
	openModal,
	openUnassignModal,
	employeesGetListWithSalary,
}) => {
	const tabs = ["Details", "Assignment History", "Audit Logs"];
	const { id } = useParams();

	useEffect(() => {
		if (id) getAsset(id);
	}, [id]);

	useEffect(() => {
		employeesGetListWithSalary();
	}, []);

	if (!asset?.id) return <LoadingContent />;

	return (
		<>
			<AssignAssetModal />
			<UnassignAssetModal />
			<div className="content">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">{asset ? asset.name : "Asset"}</h1>
							{assignedTo && (
								<p>
									Currently Assigned to:{" "}
									<Link to={`/organisation/people/${asset?.assignedTo?.agreement}`}>
										{assignedTo}
									</Link>
								</p>
							)}
						</div>
						{!assignedTo ? (
							<div
								className="btn btn-success pull-right"
								onClick={() => openModal()}
							>
								<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								<div style={{ float: "left" }}>Assign to Employee</div>
							</div>
						) : (
							<div
								className="btn btn-danger pull-right"
								onClick={() => openUnassignModal()}
							>
								<MinusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								<div style={{ float: "left" }}>Unassign Employee</div>
							</div>
						)}
					</div>
				</div>
			</div>

			<div className="content bg-white">
				<ul className="nav nav-tabs nav-tabs-alt nav-justified">
					{tabs.map((mappedTab) => (
						<li
							key={`assetTab-${mappedTab}`}
							className={tab == `${mappedTab}` ? "active" : ""}
						>
							<a
								href="#"
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									assetTab(mappedTab);
								}}
							>
								{mappedTab}
							</a>
						</li>
					))}
				</ul>

				{tab == "Details" && <AssetDetails edit={true} />}
				{tab == "Assignment History" && <AssignmentHistory />}
				{tab == "Audit Logs" && <AssetAuditLogs />}
				<div className="clearfix"></div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const currentEmployee = state.employees?.employeeListWithSalary?.find(
		(item) => item.id === state.asset?.item?.assignedTo?.agreement,
	);
	const currentEmployeeName = currentEmployee
		? `${currentEmployee?.employeeName} ${currentEmployee?.employeeSurname}`
		: undefined;

	return {
		tab: state.asset?.tab || "Details",
		asset: state.asset?.item,
		assignedTo: currentEmployeeName,
		permission: state?.permissions?.my?.permissions?.assets != "None",
	};
};

const mapDispatchToProps = (dispatch) => ({
	getAsset: (id) => dispatch(ASSET_ACTIONS.getAsset(id)),
	assetTab: (tab) => dispatch(ASSET_ACTIONS.assetTab(tab)),
	openModal: () => dispatch(ASSET_ACTIONS.assignEmployeeModal(true)),
	openUnassignModal: () => dispatch(ASSET_ACTIONS.unassignEmployeeModal(true)),
	employeesGetListWithSalary: () =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary({
				from: format(addMonths(new Date(), -12), "yyyy-MM-01"),
				to: format(new Date(), "yyyy-12-31"),
			}),
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(Asset);
